import React from "react";
import { IBlog } from "../../../../types/blogs.type";
import SmallWhiteButton from "../../../buttons/WhiteButton/SmallWhiteButton";
import ViewInput from "../inputs/ViewInput/ViewInput";
import styles from "./styles.view.module.scss";

interface Props {
  blog: IBlog;
  onClose: () => void;
  onPressEdit: () => void;
}

const ViewBlogForm: React.FC<Props> = (props) => {
  return (
    <div className={styles.container}>
      {props.blog.coverImageUrl && (
        <img
          src={props.blog.coverImageUrl}
          alt={props.blog.title}
          className={styles.cover}
        />
      )}
      <div className={styles.form}>
        <ViewInput title="Title" value={props.blog.title} />
        <ViewInput title="Slug" value={props.blog.slug} />
        <ViewInput title="Type" value={props.blog.type} />
        <ViewInput title="Status" value={props.blog.status} />
        <div className={styles.contentBlock}>
          <span className={styles.contentLabel}>Content</span>
          <div
            className={styles.content}
            dangerouslySetInnerHTML={{ __html: props.blog.content }}
          />
        </div>
      </div>
      <div className={styles.buttons}>
        <SmallWhiteButton onClick={props.onClose} title="Close" />
        <SmallWhiteButton onClick={props.onPressEdit} title="Edit" />
      </div>
    </div>
  );
};

export default ViewBlogForm;
